module.exports = __webpack_public_path__ + "static/media/customer_graphics_hlt_information.75d32c9c.svg";